import { Text, Code, FormattedDateTime } from '@customerio/pluma-components/react';
import type { SearchResult } from '@/services/auth/types';
import { isEmptyString } from '@/utils/string';
import { MetadataRow } from './metadata-row';

type Props = { result: Extract<SearchResult, { kind: 'transactional_message' }> };

// Record<string, string> (rather than the precise literal union) so a future
// backend addition still renders gracefully — it falls through to the raw
// value at the call site instead of becoming a type error users would see.
const MESSAGE_TYPE_LABELS: Record<string, string> = {
  email: 'Email',
  push: 'Push',
  in_app: 'In-app',
  twilio: 'SMS',
  inbox: 'Inbox',
  unknown: 'Unknown',
};

const STATE_LABELS: Record<string, string> = {
  draft: 'Draft',
  active: 'Active',
};

export function TransactionalMessagePreview({ result }: Props) {
  const { id, message_type, state, created_at, updated_at } = result.other;
  const typeLabel = !isEmptyString(message_type) ? (MESSAGE_TYPE_LABELS[message_type] ?? message_type) : null;
  const stateLabel = !isEmptyString(state) ? (STATE_LABELS[state] ?? state) : null;

  return (
    <>
      <MetadataRow label="ID">
        <Code size="xs">{id}</Code>
      </MetadataRow>
      {typeLabel !== null ? (
        <MetadataRow label="Type">
          <Text size="xs">{typeLabel}</Text>
        </MetadataRow>
      ) : null}
      {stateLabel !== null ? (
        <MetadataRow label="State">
          <Text size="xs">{stateLabel}</Text>
        </MetadataRow>
      ) : null}
      <MetadataRow label="Created">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={created_at} format="medium" />
        </Text>
      </MetadataRow>
      <MetadataRow label="Updated">
        <Text size="xs">
          <FormattedDateTime className="fs-mask" date={updated_at} format="medium" />
        </Text>
      </MetadataRow>
    </>
  );
}
